// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnterEmail{
    color: white;
    width: 100%;
    max-width: 100%;
}
.enterEmailContainer{
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 2px;
    width: 100%;
    max-width: 100%;
}

/* Email validation message styles */
.validationMessage {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    z-index: 10;
}

.validationMessage.success {
    background: #4caf50;
    color: white;
}

.validationMessage.info {
    background: #2196f3;
    color: white;
}

.validationMessage .loader {
    width: 16px;
    height: 16px;
}

/* Error tooltip styles with success/error variants */
.errorTooltip {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    margin-top: 4px;
    white-space: wrap;
    z-index: 10;
    pointer-events: none;
    display: inline-block;
    padding: 6px 10px;
    border-radius: 6px;
    line-height: 1.2;
}

.errorTooltip.tooltipSuccess {
    background-color: #22c55e; /* green-500 */
    color: #ffffff;
}

.errorTooltip.tooltipError {
    background-color: #ef4444; /* red-500 */
    color: #ffffff;
}
.passwordInputsContainer{
    margin-top: 30px;
    width: 100%;
}
.senOtpBtnContainer{
    margin-top: 35px;
}
.checkboxContainer {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 20px;
    width: 100%;
}
.checkboxContainer input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border: 2px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
    flex-shrink: 0;
    margin-top: 2px;
}
.checkboxContainer input[type="checkbox"]:checked {
    background-color: #00c9a7;
    border-color: #00c9a7;
}
.checkboxContainer input[type="checkbox"]:checked::after {
    content: "✓";
    position: absolute;
    color: white;
    font-size: 14px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.checkboxLabel{
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
    flex: 1 1;
}
.irregularText{
    color: #00c9a7;
    cursor: pointer;
    text-decoration: underline;
}

/* Referral Code Validation Styles */
.validationLoader {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
}

.validIcon {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #00c9a7;
    font-size: 16px;
    font-weight: bold;
}

/* Button styles for EnterEmail component */
.btnContainer {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 31.51vw;
    height: 4.8vh;
    background-color: #48d1cc;
    border-radius: 30px;
    margin-top: 28px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Inter", sans-serif;
}
/* 
.btnContainer:hover {
    background-color: #3bc4c0;
    transform: translateY(-1px);
} */
.btnContainerDuplicate {
    background-color: #3a3a4a !important;
  }
.btnContainer:active {
    transform: translateY(0);
}

.btnContainer:disabled {
    background-color: #666;
    cursor: not-allowed;
    transform: none;
}

.btnText {
    all: unset;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: white;
}

/* Tablet and small desktop adjustments */
@media (max-width: 1640px) {
    .checkboxLabel{
        font-size: 14px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 16px;
        height: 16px;
    }
}

@media (max-width: 1440px) {
    .checkboxLabel{
        font-size: 12px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 14px;
        height: 14px;
    }
}

@media (max-width: 1280px) {
    .checkboxLabel{
        font-size: 10px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 12px;
        height: 12px;
        border-radius: 3px;
    }
}

@media (max-width: 1024px) {
    .checkboxLabel{
        font-size: 8px;
    }
    .checkboxContainer input[type="checkbox"] {
        width: 10px;
        height: 10px;
        border-radius: 3px;
    }
}

/* Mobile responsive styles */
@media (max-width: 768px) {
    /* Ensure the visibility toggle icon is perfectly centered on small devices */
    .EnterEmail .eyeIcon{
        position: absolute;
        right: 16px;
        top: 0;
        bottom: 0;
        transform: none;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 36px;
    }
    .enterEmailContainer {
        gap: 8px;
        padding: 0 16px 0 16px;
    }
    
    .passwordInputsContainer {
        margin-top: 24px;
    }
    
    .checkboxContainer {
        margin-top: 16px;
        gap: 12px;
        align-items: flex-start;
    }
    
    .checkboxContainer input[type="checkbox"] {
        width: 20px;
        height: 20px;
        border-radius: 4px;
        margin-top: 0;
    }
    
    .checkboxContainer input[type="checkbox"]:checked::after {
        font-size: 16px;
    }
    
    .checkboxLabel {
        font-size: 14px;
        line-height: 20px;
        flex: 1 1;
    }
    
    .irregularText {
        font-size: 14px;
    }
    
    .btnContainer {
        width: calc(100% - 32px) !important;
        height: 52px;
        border-radius: 14px;
        margin-top: 24px;
        font-size: 16px;
        background: linear-gradient(135deg,#48d1cc 0%,#3bb5a8 100%);
        box-shadow: 0 8px 20px rgba(59,181,168,0.25);
        margin-left: auto;
        margin-right: auto;
    }
    
    .btnText {
        font-size: 16px;
        font-weight: 600;
    }
}

@media (max-width: 480px) {
    .enterEmailContainer {
        gap: 8px;
        padding: 0 12px 0 12px;
    }
    
    .passwordInputsContainer {
        margin-top: 20px;
    }
    
    .checkboxContainer {
        margin-top: 14px;
        gap: 10px;
    }
    
    .checkboxContainer input[type="checkbox"] {
        width: 18px;
        height: 18px;
    }
    
    .checkboxContainer input[type="checkbox"]:checked::after {
        font-size: 14px;
    }
    
    .checkboxLabel {
        font-size: 13px;
        line-height: 18px;
    }
    
    .irregularText {
        font-size: 13px;
    }
    
    .btnContainer {
        height: 48px;
        border-radius: 12px;
        margin-top: 20px;
        width: calc(100% - 24px) !important;
        margin-left: auto;
        margin-right: auto;
    }
    
    .btnText {
        font-size: 15px;
        font-weight: 600;
    }
}

@media (max-width: 360px) {
    .enterEmailContainer {
        padding: 0 8px 0 8px;
    }
    
    .checkboxContainer {
        gap: 8px;
        margin-top: 12px;
    }
    
    .checkboxContainer input[type="checkbox"] {
        width: 16px;
        height: 16px;
    }
    
    .checkboxContainer input[type="checkbox"]:checked::after {
        font-size: 12px;
    }
    
    .checkboxLabel {
        font-size: 12px;
        line-height: 16px;
    }
    
    .irregularText {
        font-size: 12px;
    }
    
    .btnContainer {
        height: 44px;
        border-radius: 10px;
        margin-top: 16px;
        width: calc(100% - 16px) !important;
        margin-left: auto;
        margin-right: auto;
    }
    
    .btnText {
        font-size: 14px;
        font-weight: 600;
    }
}






`, "",{"version":3,"sources":["webpack://./src/Components/SignUpFlow/EnterEmail/EnterEmail.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,qDAAqD;AACrD;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB,EAAE,cAAc;IACzC,cAAc;AAClB;;AAEA;IACI,yBAAyB,EAAE,YAAY;IACvC,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,SAAO;AACX;AACA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA,2CAA2C;AAC3C;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;AACpC;AACA;;;;GAIG;AACH;IACI,oCAAoC;EACtC;AACF;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA,yCAAyC;AACzC;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,6EAA6E;IAC7E;QACI,kBAAkB;QAClB,WAAW;QACX,MAAM;QACN,SAAS;QACT,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,WAAW;IACf;IACA;QACI,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,SAAO;IACX;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mCAAmC;QACnC,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,2DAA2D;QAC3D,4CAA4C;QAC5C,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,mCAAmC;QACnC,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,gBAAgB;QAChB,mCAAmC;QACnC,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".EnterEmail{\n    color: white;\n    width: 100%;\n    max-width: 100%;\n}\n.enterEmailContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 2px;\n    width: 100%;\n    max-width: 100%;\n}\n\n/* Email validation message styles */\n.validationMessage {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 400;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: all 0.3s ease;\n    z-index: 10;\n}\n\n.validationMessage.success {\n    background: #4caf50;\n    color: white;\n}\n\n.validationMessage.info {\n    background: #2196f3;\n    color: white;\n}\n\n.validationMessage .loader {\n    width: 16px;\n    height: 16px;\n}\n\n/* Error tooltip styles with success/error variants */\n.errorTooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    font-size: 12px;\n    margin-top: 4px;\n    white-space: wrap;\n    z-index: 10;\n    pointer-events: none;\n    display: inline-block;\n    padding: 6px 10px;\n    border-radius: 6px;\n    line-height: 1.2;\n}\n\n.errorTooltip.tooltipSuccess {\n    background-color: #22c55e; /* green-500 */\n    color: #ffffff;\n}\n\n.errorTooltip.tooltipError {\n    background-color: #ef4444; /* red-500 */\n    color: #ffffff;\n}\n.passwordInputsContainer{\n    margin-top: 30px;\n    width: 100%;\n}\n.senOtpBtnContainer{\n    margin-top: 35px;\n}\n.checkboxContainer {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin-top: 20px;\n    width: 100%;\n}\n.checkboxContainer input[type=\"checkbox\"] {\n    appearance: none;\n    -webkit-appearance: none;\n    width: 18px;\n    height: 18px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n    position: relative;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n.checkboxContainer input[type=\"checkbox\"]:checked {\n    background-color: #00c9a7;\n    border-color: #00c9a7;\n}\n.checkboxContainer input[type=\"checkbox\"]:checked::after {\n    content: \"✓\";\n    position: absolute;\n    color: white;\n    font-size: 14px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.checkboxLabel{\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    cursor: pointer;\n    flex: 1;\n}\n.irregularText{\n    color: #00c9a7;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n/* Referral Code Validation Styles */\n.validationLoader {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 20px;\n    height: 20px;\n}\n\n.validIcon {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #00c9a7;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* Button styles for EnterEmail component */\n.btnContainer {\n    all: unset;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 31.51vw;\n    height: 4.8vh;\n    background-color: #48d1cc;\n    border-radius: 30px;\n    margin-top: 28px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-family: \"Inter\", sans-serif;\n}\n/* \n.btnContainer:hover {\n    background-color: #3bc4c0;\n    transform: translateY(-1px);\n} */\n.btnContainerDuplicate {\n    background-color: #3a3a4a !important;\n  }\n.btnContainer:active {\n    transform: translateY(0);\n}\n\n.btnContainer:disabled {\n    background-color: #666;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.btnText {\n    all: unset;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    color: white;\n}\n\n/* Tablet and small desktop adjustments */\n@media (max-width: 1640px) {\n    .checkboxLabel{\n        font-size: 14px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 16px;\n        height: 16px;\n    }\n}\n\n@media (max-width: 1440px) {\n    .checkboxLabel{\n        font-size: 12px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 14px;\n        height: 14px;\n    }\n}\n\n@media (max-width: 1280px) {\n    .checkboxLabel{\n        font-size: 10px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 12px;\n        height: 12px;\n        border-radius: 3px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .checkboxLabel{\n        font-size: 8px;\n    }\n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 10px;\n        height: 10px;\n        border-radius: 3px;\n    }\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n    /* Ensure the visibility toggle icon is perfectly centered on small devices */\n    .EnterEmail .eyeIcon{\n        position: absolute;\n        right: 16px;\n        top: 0;\n        bottom: 0;\n        transform: none;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n        width: 36px;\n    }\n    .enterEmailContainer {\n        gap: 8px;\n        padding: 0 16px 0 16px;\n    }\n    \n    .passwordInputsContainer {\n        margin-top: 24px;\n    }\n    \n    .checkboxContainer {\n        margin-top: 16px;\n        gap: 12px;\n        align-items: flex-start;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 20px;\n        height: 20px;\n        border-radius: 4px;\n        margin-top: 0;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"]:checked::after {\n        font-size: 16px;\n    }\n    \n    .checkboxLabel {\n        font-size: 14px;\n        line-height: 20px;\n        flex: 1;\n    }\n    \n    .irregularText {\n        font-size: 14px;\n    }\n    \n    .btnContainer {\n        width: calc(100% - 32px) !important;\n        height: 52px;\n        border-radius: 14px;\n        margin-top: 24px;\n        font-size: 16px;\n        background: linear-gradient(135deg,#48d1cc 0%,#3bb5a8 100%);\n        box-shadow: 0 8px 20px rgba(59,181,168,0.25);\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n    .btnText {\n        font-size: 16px;\n        font-weight: 600;\n    }\n}\n\n@media (max-width: 480px) {\n    .enterEmailContainer {\n        gap: 8px;\n        padding: 0 12px 0 12px;\n    }\n    \n    .passwordInputsContainer {\n        margin-top: 20px;\n    }\n    \n    .checkboxContainer {\n        margin-top: 14px;\n        gap: 10px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 18px;\n        height: 18px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"]:checked::after {\n        font-size: 14px;\n    }\n    \n    .checkboxLabel {\n        font-size: 13px;\n        line-height: 18px;\n    }\n    \n    .irregularText {\n        font-size: 13px;\n    }\n    \n    .btnContainer {\n        height: 48px;\n        border-radius: 12px;\n        margin-top: 20px;\n        width: calc(100% - 24px) !important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n    .btnText {\n        font-size: 15px;\n        font-weight: 600;\n    }\n}\n\n@media (max-width: 360px) {\n    .enterEmailContainer {\n        padding: 0 8px 0 8px;\n    }\n    \n    .checkboxContainer {\n        gap: 8px;\n        margin-top: 12px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"] {\n        width: 16px;\n        height: 16px;\n    }\n    \n    .checkboxContainer input[type=\"checkbox\"]:checked::after {\n        font-size: 12px;\n    }\n    \n    .checkboxLabel {\n        font-size: 12px;\n        line-height: 16px;\n    }\n    \n    .irregularText {\n        font-size: 12px;\n    }\n    \n    .btnContainer {\n        height: 44px;\n        border-radius: 10px;\n        margin-top: 16px;\n        width: calc(100% - 16px) !important;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n    .btnText {\n        font-size: 14px;\n        font-weight: 600;\n    }\n}\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
